var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            {
              staticClass: "d-flex align-items-center",
              attrs: { cols: "10", sm: "8" },
            },
            [
              _c("h5", { staticClass: "bold mb-0" }, [
                _vm._v(
                  "\n        " + _vm._s(_vm.accountPlanTitle) + "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "b-col",
            {
              staticClass: "d-flex justify-content-end align-items-center",
              attrs: { cols: "2", sm: "4" },
            },
            [
              _vm.RETRY_PAYMENT_URL
                ? _c(
                    "a",
                    {
                      staticClass:
                        "btn btn-danger btn-sm text-decoration-none text-white",
                      attrs: { target: "_blank", href: _vm.RETRY_PAYMENT_URL },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("account.accountPlan.retryPayment")) +
                          "\n        "
                      ),
                      _c("icon", { attrs: { name: "external-link" } }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "mt-3 mb-0" },
        [
          _vm.showPayerInfo
            ? _c("i18n", {
                attrs: {
                  path: "account.accountPlan.yourAccountIsBeingPaidBy",
                  tag: "span",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "who",
                      fn: function () {
                        return [
                          _c(
                            "profile-avatar",
                            _vm._b(
                              {
                                staticClass: "client-avatar mx-2",
                                staticStyle: {
                                  width: "1.5rem",
                                  height: "1.5rem",
                                },
                              },
                              "profile-avatar",
                              _vm.PAYER,
                              false
                            )
                          ),
                          _vm._v(" "),
                          _vm.isBroker
                            ? _c(
                                "router-link",
                                {
                                  staticClass: "bold text-primary clickable",
                                  attrs: {
                                    to: {
                                      name: "agent-details",
                                      params: {
                                        agentId: _vm.PAYER.username,
                                        agent: _vm.PAYER,
                                      },
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm._f("fullName")(_vm.PAYER)) +
                                      "\n          "
                                  ),
                                  _c("icon", {
                                    attrs: { name: "external-link" },
                                  }),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.bottom",
                                      value: _vm.PAYER.email,
                                      expression: "PAYER.email",
                                      modifiers: { bottom: true },
                                    },
                                  ],
                                  staticClass: "bold text-primary clickable",
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm._f("fullName")(_vm.PAYER)) +
                                      "\n        "
                                  ),
                                ]
                              ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3119470982
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("i18n", {
            attrs: { path: _vm.accountPlanSubTitlePath, tag: "span" },
            scopedSlots: _vm._u([
              {
                key: "when",
                fn: function () {
                  return [
                    _vm.ACCOUNT_EXPIRATION_DATE
                      ? _c("span", { staticClass: "ml-1 text-primary bold" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm._f("formatDateExpiration")(
                                  _vm.ACCOUNT_EXPIRATION_DATE
                                )
                              ) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }